import type { FC, PropsWithChildren, Ref } from 'react';
import React from 'react';

import type { IClassNameProps } from '@bem-react/core';

import { cnRadioButton } from '../RadioButton.cn';

import './RadioButton-Radio.css';

export interface IRadioButtonRadioProps
    extends
        IClassNameProps,
        PropsWithChildren<{
            /**
             * HTML атрибут `for`.
             */
            htmlFor?: string;

            /**
             * Выбранное состояние.
             */
            checked?: boolean;

            /**
             * Состояние доступности компонента.
             */
            disabled?: boolean;
            /**
             * Колбэк-реф.
             */
            innerRef?: Ref<HTMLLabelElement>;
        }> {}

export const RadioButtonRadio: FC<IRadioButtonRadioProps> = ({
    checked,
    disabled,
    className,
    innerRef,
    children,
    ...props
}) => (
    <label
        {...props}
        className={cnRadioButton('Radio', { checked, disabled }, [className])}
        ref={innerRef}
    >
        {children}
    </label>
);
